import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { StyledMarkdown } from 'components/StyledMarkdown';
import * as Types from 'types/types';
import { StyledFooter, StyledHeader } from './ResumePreviewChrome';
import { resumeStyles } from './resumePreviewStyles';

import './ResumePreview.css';

export { resumeStyles };
export type { ResumeStyle } from './resumePreviewStyles';

export interface ResumePreviewProps {
  resume: Types.Resume;
  selectedStyle?: string;
  shadeMargins?: boolean;
}

export const ResumePreview: React.FC<ResumePreviewProps> = (props: ResumePreviewProps) => {
  const { resume, selectedStyle = 'corporate', shadeMargins = true } = props;
  const currentStyle = resumeStyles[selectedStyle] || resumeStyles.corporate;
  const job: Types.Job | null = resume.job || null;
  const candidate: Types.Candidate | null = resume.candidate || null;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!resume || !candidate || !job) {
    return (
      <Box className="ResumePreview" sx={{ p: 2 }}>
        <Typography variant="body1">No resume data available.</Typography>
      </Box>
    );
  }

  return (
    <Box
      className="ResumePreview document-container"
      sx={{
        ...currentStyle.contentStyle,
        position: 'relative',
        height: 'fit-content',
        minHeight: 'fit-content',
        display: 'flex',
        m: 0,
        p: 0,
      }}
    >
      <Box
        className={`a4-document ${shadeMargins ? 'with-margins' : ''}`}
        sx={{
          backgroundColor: currentStyle.color.background,
          padding: 5,
          minHeight: '100vh',
          height: 'fit-content',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <StyledHeader isMobile={isMobile} candidate={candidate} style={currentStyle} />

        <Box sx={currentStyle.markdownStyle}>
          <StyledMarkdown
            sx={{
              position: 'relative',
              maxHeight: '100%',
              display: 'flex',
              flexGrow: 1,
              flex: 1,
              ...currentStyle.markdownStyle,
            }}
            content={resume.resume}
          />
        </Box>

        {job && <StyledFooter isMobile={isMobile} resume={resume} style={currentStyle} />}
      </Box>
    </Box>
  );
};

export default ResumePreview;
